import React, { Component } from "react";
import { Select, Radio, Space, message, Spin, Checkbox, Input } from "antd";
import Bridge from "../../utils/Bridge";

const { Option } = Select;
const {TextArea} =Input;

export default class LanguageEducation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_english_first_language: "",
      highest_education: "",
      education_other_specification: "",
      occupation: "",
      loading: false,
      if_not_english_first_language: "",
      if_not_english_first_language_other: "",
      highest_education_option_list:[
        "No formal education",
        "Elementary School",
        "High School",
        "College",
        "Vocational Training",
        "University",
        "Masters",
        "Doctorate",
        "Other"
      ],
      doctorate_option_list:["Masters","PhD","Other"],
      doctorate_other_options:[],
      united_state_region_option_list:[
        "Northeast",
        "Midwest",
        "South",
        "West",
        "None" 
      ],
      united_state_region:"",
      if_not_from_united_state_other_location:"",
      residence_type_list: [
        "Apartment",
        "Condo/townhouse",
        "House",
        "Mobile home",
        "Other",
      ],
      residence_type: "",
      other_residence_type:"",
      doctorate_other_specification:"",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.ecas_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Is English your first language?") {
                this.setState({ is_english_first_language: item.value });
              }
              if (item.field == "If not English your first language") {
                this.setState({ if_not_english_first_language: item.value });
              }
              if (
                item.field ==
                "If not English your first language other specification"
              ) {
                this.setState({
                  if_not_english_first_language_other: item.value,
                });
              }
              if (item.field == "Highest level of education?") {
                this.setState({ highest_education: item.value });
              }
              if (
                item.field == "Highest Level Of Education Other Specification"
              ) {
                this.setState({ education_other_specification: item.value });
              }
              if (item.field == "What is your occupation?") {
                this.setState({ occupation: item.value });
              }
              if (item.field == "Highest Level Of Education - Doctorate") {
                this.setState({ doctorate_other_options: item.value ?JSON.parse(item.value):[] });
              }
              if(item.field=='Which region in the United States do you consider yourself from?'){
                this.setState({ united_state_region: item.value });
              }
              if(item.field=='Which region in the United States do you consider yourself from? - Other'){
                this.setState({ if_not_from_united_state_other_location: item.value });
              }
              if (item.field == "Residence Type") {
                this.setState({ residence_type: item.value });
              }
              if (item.field == "Residence Type - Other") {
                this.setState({ other_residence_type: item.value });
              }
              if (item.field == "Highest Level Of Education - Doctorate Other") {
                this.setState({ doctorate_other_specification: item.value });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeHighestEducation = (event) => {
    this.setState({
      highest_education: event.target.value,
      education_other_specification: "",
    });
  };
  save = () => {
    if (!this.state.is_english_first_language) {
      message.warning("Please select 'Is English your first language?'");
      return;
    }
    if(this.state.is_english_first_language=='No'){
      if (!this.state.if_not_english_first_language) {
        message.warning("Please select 'If not English your first language'");
        return;
      }

      if (this.state.if_not_english_first_language=='Other') {
        message.warning("Please enter 'If not English your first language other specification'");
        return;
      }
    }

    let questions = [
      {
        parent_field: "Is English your first language?",
        field: "Is English your first language?",
        value: this.state.is_english_first_language,
      },
      {
        parent_field: "If not English your first language",
        field: "If not English your first language",
        value: this.state.if_not_english_first_language,
      },
      {
        parent_field: "If not English your first language other specification",
        field: "If not English your first language other specification",
        value: this.state.if_not_english_first_language_other,
      },
      {
        parent_field: "Highest level of education?",
        field: "Highest level of education?",
        value: this.state.highest_education,
      },
      {
        parent_field: "Highest Level Of Education Other Specification",
        field: "Highest Level Of Education Other Specification",
        value: this.state.education_other_specification,
      },
      {
        parent_field: "What is your occupation?",
        field: "What is your occupation?",
        value: this.state.occupation,
      },
      {
        parent_field: "Highest Level Of Education - Doctorate",
        field: "Highest Level Of Education - Doctorate",
        value: JSON.stringify(this.state.doctorate_other_options),
      },
      {
        parent_field: "Highest Level Of Education - Doctorate Other",
        field: "Highest Level Of Education - Doctorate Other",
        value: this.state.doctorate_other_specification,
      },
      {
        parent_field: "Which region in the United States do you consider yourself from?",
        field: "Which region in the United States do you consider yourself from?",
        value: this.state.united_state_region,
      },
      {
        parent_field: "Which region in the United States do you consider yourself from? - Other",
        field: "Which region in the United States do you consider yourself from? - Other",
        value: this.state.if_not_from_united_state_other_location,
      },
      {
        parent_field: "Residence Type",
        field: "Residence Type",
        value: this.state.residence_type
      },
      {
        parent_field: "Residence Type - Other",
        field: "Residence Type - Other",
        value: this.state.other_residence_type
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "3",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics.ecas_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(5);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeDoctorate=(event)=>{
    let value = event.target.value;
    let tempArr = this.state.doctorate_other_options?this.state.doctorate_other_options:[];
    if(!tempArr.includes('Other')){
      this.setState({ doctorate_other_specification: "" });
    }
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      this.setState({ doctorate_other_options: newArray });
    } else {
      tempArr.push(value);
      this.setState({ doctorate_other_options: tempArr });
    }   
  }
  render() {
    return (
      <div>
        <div className="header">
          <h3>LANGUAGE, EDUCATION AND OCCUPATION</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="input-heading">
                Is English your first language? <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    is_english_first_language: e.target.value,
                    if_not_english_first_language: "",
                  })
                }
                value={this.state.is_english_first_language}
                direction="vertical"
              >
                <Space direction="vertical">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
              <div className="row">
                {this.state.is_english_first_language == "No" && (
                  <div className="col-lg-6">
                    <Select
                      onChange={(value) =>
                        this.setState({ if_not_english_first_language: value })
                      }
                      value={this.state.if_not_english_first_language}
                      style={{
                        width: "100%",
                        height: 55,
                        maxWidth: 500,
                        marginTop: 20,
                      }}
                    >
                      <Option value="">Select Language:</Option>
                      <Option value="Arabic">Arabic</Option>
                      <Option value="French">French</Option>
                      <Option value="German">German</Option>
                      <Option value="Hindi">Hindi</Option>
                      <Option value="Japanese">Japanese</Option>
                      <Option value="Korean">Korean</Option>
                      <Option value="Mandarin">Mandarin</Option>
                      <Option value="Portuguese">Portuguese</Option>
                      <Option value="Spanish">Spanish</Option>
                      <Option value="Russian">Russian</Option>
                      <Option value="Urdu">Urdu</Option>
                      <Option value="Other">Other</Option>
                    </Select>
                  </div>
                )}
                {this.state.if_not_english_first_language == "Other" && (
                  <div className="col-lg-6">
                    <input
                      type="text"
                      name="if_not_english_first_language_other"
                      placeholder="Enter Language"
                      value={this.state.if_not_english_first_language_other}
                      onChange={(e) => {
                        this.setState({
                          if_not_english_first_language_other: e.target.value,
                        });
                      }}
                      style={{
                        width: "100%",
                        height: 55,
                        maxWidth: 500,
                        marginTop: 20,
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="form-group">
              <label className="input-heading">
                Highest level of education?
              </label>
              <br />
              <Radio.Group
                onChange={this.onChangeHighestEducation}
                value={this.state.highest_education}
                direction="vertical"
              >
                <Space direction="vertical">
                  {this.state.highest_education_option_list.map(
                    (option, index) => (
                      <Radio key={index} value={option}>
                        {option}
                      </Radio>
                    )
                  )}
                </Space>
              </Radio.Group>
            </div>
            {this.state.highest_education == "Other" && (
              <div className="form-group">
                <label className="input-heading">
                  Specification
                </label>
                <br />
                <textarea
                  name="education_other_specification"
                  value={this.state.education_other_specification}
                  onChange={(e) => {
                    this.setState({
                      education_other_specification: e.target.value,
                    });
                  }}
                  rows="4"
                  cols="50"
                  maxlength="200"
                ></textarea>
              </div>
            )}
            {this.state.highest_education == "Doctorate" && (
              <div className="mb-4">
                <label className="input-heading">
                  Doctorate Specification
                </label>
                <br />
                {this.state.doctorate_option_list.map(
                  (option, index) => (
                    <Checkbox
                      key={index}
                      value={option}
                      onChange={this.onChangeDoctorate}
                      checked={this.state.doctorate_other_options.includes(
                        option
                      )}
                    >
                      {option}
                    </Checkbox>
                  )
                )}
                {this.state.doctorate_other_options.includes('Other') && (
                  <div>
                    <label className="input-heading col-lg-5 pl-0 mt-4 tt-capitalize mb-2">
                      Specification
                    </label><br/>
                    <TextArea
                      style={{
                        padding: 16,
                        fontSize: 18,
                      }}
                      rows={4}
                      placeholder="Specification..."
                      name="doctorate_other_specification"
                      value={
                        this.state.doctorate_other_specification
                      }
                      onChange={(e) => {
                        this.setState({
                          doctorate_other_specification:
                            e.target.value,
                        });
                      }}
                    />
                  </div>
                )}
              </div>
            )}
            <div className="form-group">
              <label className="input-heading">
                Which region in the United States do you consider yourself from?{" "}
               
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    united_state_region: e.target.value,
                    if_not_from_united_state_other_location :""
                  })
                }
                value={this.state.united_state_region}
                direction="vertical"
              >
                <Space direction="vertical">
                  {this.state.united_state_region_option_list.map(
                    (option, index) => (
                      <Radio key={index} value={option}>
                        {option}
                      </Radio>
                    )
                  )}
                </Space>
              </Radio.Group>
              {this.state.united_state_region == "None" && (
              <div className="form-group mt-3">
                <label className="input-heading">
                  Specification
                </label>
                <br />
                <textarea
                  name="if_not_from_united_state_other_location"
                  value={this.state.if_not_from_united_state_other_location}
                  onChange={(e) => {
                    this.setState({
                      if_not_from_united_state_other_location: e.target.value,
                    });
                  }}
                  rows="4"
                  cols="50"
                  maxlength="200"
                ></textarea>
              </div>
            )}
            </div>
            <div className="form-group">
              <label className="input-heading">
                Residence Type
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    residence_type: e.target.value,
                    other_residence_type:""
                  })
                }
                value={this.state.residence_type}
                direction="vertical"
              >
                <Space direction="vertical">
                  {this.state.residence_type_list.map(
                    (option, index) => (
                      <Radio key={index} value={option}>
                        {option}
                      </Radio>
                    )
                  )}
                </Space>
              </Radio.Group>
            </div>
            {this.state.residence_type == "Other" && (
              <div className="form-group mt-3">
                <label className="input-heading">
                  Specification
                </label>
                <br />
                <textarea
                  name="other_residence_type"
                  value={this.state.other_residence_type}
                  onChange={(e) => {
                    this.setState({
                      other_residence_type: e.target.value,
                    });
                  }}
                  rows="4"
                  cols="50"
                  maxlength="200"
                ></textarea>
              </div>
            )}
            <div className="form-group">
              <label className="mb-2 input-heading">
                What is your occupation?
              </label>
              <br />
              <input
                type="text"
                name="occupation"
                value={this.state.occupation}
                onChange={(e) => this.setState({ occupation: e.target.value })}
              />
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button"
                  style={{
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(3)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
